<div class="row">
    <app-header-full></app-header-full>
    <qb-app-alert></qb-app-alert>
    <main class="col">
        <ng-content></ng-content>
    </main>
    <app-footer></app-footer>
</div>
